import { Link, useNavigate } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import * as Yup from "yup";

import Master from "../../../Layouts/Master";
import { useApi } from "../../../Hooks/Api";
import { AgeContext } from "../Context/AgeContext";
import { useToast } from "../../../Hooks/Toast";
import Loading from "../../../Components/Loading/Loading";
import { Datepicker, Form, Text, Select } from "../../../Components/Form";
import { getStatus, serverErrorHandler } from "../../../Utils/Helpers";
import TitleBar from "../../../Components/TitleBar/TitleBar";

const validationSchema = Yup.object({
  title: Yup.string()
    .typeError("عنوان الزامی است")
    .required("عنوان الزامی است")
    .max(190, "عنوان نمی تواند بیشتر از 190 کاراکتر باشد"),
  start_age: Yup.string().required("شروع رده سنی الزامی است"),
  end_age: Yup.string().required("پایان رده سنی الزامی است"),
  status: Yup.number()
    .typeError("انتخاب وضعیت الزامی است")
    .required("انتخاب وضعیت الزامی است"),
});

const Create = () => {
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { post } = useApi();
  const { error, success } = useToast();
  const navigate = useNavigate();

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    await post(
      "/age",
      values,
      (res) => {
        success(`رده سنی "${values?.title}" باموفقیت ایجاد شد.`);
        setFormSubmitLoaing(false);
        navigate("/age");
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error("لطفا خطاهای فرم را رفع کنید.");
        } else {
          error(`رده سنی "${values?.title}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      }
    );
  };
  return (
    <Master>
      <TitleBar
        title='ایجاد رده سنی'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/age'
      />
      <Form
        initialValues={{
          title: "",
          start_age: "",
          end_age: "",
          status: 1,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  title='عنوان'
                  name='title'
                  serverError={serverErrors.title}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4'>
            <div className='col-12'>
              <Datepicker
                title='شروع رده سنی'
                name='start_age'
                minDate={new Date("1830/01/01")}
                serverError={serverErrors.start_age}
              />
            </div>
            <div className='col-12'>
              <Datepicker
                title='پایان رده سنی'
                name='end_age'
                minDate={new Date("1830/01/01")}
                serverError={serverErrors.end_age}
              />
            </div>
            <div className='col-12'>
              <Select
                title='وضعیت'
                name='status'
                optionLabel='label'
                optionValue='value'
                options={getStatus()}
                serverError={serverErrors.status}
              />
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Create;
